import { css } from 'styled-components';



export const colors = {
  blue: {
    light:        '#e8e9ec',
    lightHover:   '#dcdee2',
    lightActive:  '#b7bac3',
    normal:       '#16213d',
    normalHover:  '#141e37',
    normalActive: '#121a31',
    dark:         '#11192e',
    darkHover:    '#0d1425',
    darkActive:   '#0a0f1b',
    darker:       '#080c15',
  },
  darkBlue: {
    light:        '#e7e8e9',
    lightHover:   '#dbdcde',
    lightActive:  '#b4b6bc',
    normal:       '#0d1526',
    normalHover:  '#0c1322',
    normalActive: '#0a111e',
    dark:         '#0a101d',
    darkHover:    '#080d17',
    darkActive:   '#060911',
    darker:       '#05070d',
  },
  red: {
    light:        '#f1e7e7',
    lightHover:   '#ebdadb',
    lightActive:  '#d5b3b5',
    normal:       '#770b11',
    normalHover:  '#6b0a0f',
    normalActive: '#5f090e',
    dark:         '#59080d',
    darkHover:    '#47070a',
    darkActive:   '#360508',
    darker:       '#2a0406',
  },
  green: {
    light:        '#ecf1ea',
    lightHover:   '#e3eae0',
    lightActive:  '#c4d5bf',
    normal:       '#427631',
    normalHover:  '#3b6a2c',
    normalActive: '#355e27',
    dark:         '#325925',
    darkHover:    '#28471d',
    darkActive:   '#1e3516',
    darker:       '#172911',
  },
};



export const cardDefault = css`
  background: var(--switch-input-bg, #0d1526);
  border-radius: 20px;
`;

export const cardEditing = css`
  background: var(--switch-blue-subtle, #1a253d);
  border-radius: 20px;
`;

export const cardActive = css`
  background-image: linear-gradient(
    149deg,
    rgba(62, 192, 21, 0.5) 0%,
    rgba(62, 192, 21, 0.25) 100%
  );
  border-radius: 20px;
`;

export const cardFault = css`
  background: var(--switch-danger-soft, #770b11);
  border-radius: 20px;
`;



export const cardInnerArea = css`
  background: var(--switch-panel-bg-subtle, rgba(10, 16, 29, 0.4));
  border-radius: 14px;
`;



export const toggleBase = css`
  width: 40px;
  height: 22px;
  border-radius: 9999px;
  position: relative;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &::after {
    content: '';
    position: absolute;
    top: 3px;
    width: 16px;
    height: 16px;
    border-radius: 9999px;
    background: white;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1), 0px 2px 4px rgba(0, 0, 0, 0.1);
    transition: left 0.2s ease;
  }
`;

export const toggleOff = css`
  ${toggleBase}
  background: #314158;

  &::after {
    left: 3px;
  }
`;

export const toggleOnBlue = css`
  ${toggleBase}
  background: #155dfc;

  &::after {
    left: 21px;
  }
`;

export const toggleOnGreen = css`
  ${toggleBase}
  background: #15fc1d;

  &::after {
    left: 21px;
  }
`;

export const toggleFault = css`
  ${toggleBase}
  background: #4b0d16;

  &::after {
    left: 21px;
  }
`;



export const cardButtonDefault = css`
  background: var(--switch-button-bg, #252e3e);
  border-radius: 14px;
`;

export const cardButtonEditing = css`
  background: rgba(43, 127, 255, 0.08);
  border: 0.8px solid rgba(43, 127, 255, 0.2);
  border-radius: 14px;
`;

export const cardButtonActive = css`
  background: #559d4a;
  border: 0.8px solid rgba(20, 207, 32, 0.5);
  border-radius: 14px;
`;

export const cardButtonFault = css`
  background: var(--switch-danger-soft, #4b0d16);
  border: 0.8px solid rgba(43, 127, 255, 0.2);
  border-radius: 14px;
`;



export const iconContainerDefault = css`
  background: var(--switch-button-bg, #252e3e);
  border-radius: 14px;
`;

export const iconContainerEditing = css`
  background: var(--switch-blue-subtle, #112546);
  border: 1px solid #155dfc;
  border-radius: 14px;
`;

export const iconContainerActive = css`
  background: var(--switch-panel-bg-alt, #1d293d);
  border-radius: 14px;
`;

export const iconContainerFault = css`
  background: var(--switch-danger-soft, #4b0d16);
  border-radius: 14px;
`;



export const radiusCard = '20px';
export const radiusCardInner = '14px';
export const radiusSection = '16px';
export const radiusInput = '8px';
export const radiusPill = '9999px';



export const flexBoxCenter = css`
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
`;

export const justifyContentSpaceEvenly = css`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
`;

export const justifyContentSpaceBetween = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const justifyContentSpaceAround = css`
  display: flex;
  justify-content: space-around;
  align-items: center;
`;

export const flexDirectionColumn = css`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`;

export const alignItemsFlexStart = css`
  display: flex;
  justify-content: center;
  align-items: flex-start;
`;

export const alignItemsFlexEnd = css`
  display: flex;
  justify-content: center;
  align-items: flex-end;
`;

export const justifyContentFlexStart = css`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const justifyContentFlexEnd = css`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;
export const layerA0Deg = css`
  background: transparent
    linear-gradient(
      0deg,
      var(--legacy-layer-a-start, #1e293b) 0%,
      var(--legacy-layer-a-end, #020617) 100%
    );
  box-shadow: var(--legacy-layer-shadow, inset 0px 0.5px 1px #ffffff24, 0px 0px 1px #000000);
  border: 0.5px solid var(--legacy-layer-border, #000000);
`;

export const layerA180Deg = css`
  background: transparent
    linear-gradient(
      180deg,
      var(--legacy-layer-a-start, #1e293b) 0%,
      var(--legacy-layer-a-end, #020617) 100%
    );
  box-shadow: var(--legacy-layer-shadow, inset 0px 0.5px 1px #ffffff24, 0px 0px 1px #000000);
  border: 0.5px solid var(--legacy-layer-border, #000000);
`;

export const layerA180DegLighter = css`
  background: transparent
    linear-gradient(
      180deg,
      var(--legacy-layer-a-start, #1e293b) 0%,
      var(--legacy-layer-a-end-soft, #1f344c) 100%
    );
  box-shadow: var(--legacy-layer-shadow, inset 0px 0px 2px #ffffff29, 0px 0px 1px #000000);
  border: 1px solid var(--legacy-layer-border, #000000);
`;

export const layerAGreen180Deg = css`
  background: transparent linear-gradient(180deg, #22c55e 0%, #14532d 100%);
  box-shadow: inset 0px 0.5px 1px #ffffff24, 0px 0px 1px #000000;
  border: 0.5px solid #000000;
`;

export const layerADisabled180Deg = css`
  background: transparent
    linear-gradient(
      180deg,
      var(--legacy-layer-disabled-start, #475569) 0%,
      var(--legacy-layer-disabled-end, #1d1d1d) 100%
    );
  box-shadow: var(--legacy-layer-shadow, inset 0px 0.5px 1px #ffffff24, 0px 0px 1px #000000);
  border: 0.5px solid var(--legacy-layer-border, #000000);
`;

export const layerDisabled180Deg = css`
  ${layerADisabled180Deg}
  cursor: not-allowed;
`;

export const layerA90Deg = css`
  background: transparent
    linear-gradient(
      90deg,
      var(--legacy-layer-a-start, #1e293b) 0%,
      var(--legacy-layer-a-end, #020617) 100%
    );
  box-shadow: var(--legacy-layer-shadow, inset 0px 0.5px 1px #ffffff24, 0px 0px 1px #000000);
  border: 0.5px solid var(--legacy-layer-border, #000000);
`;
export const layerA270Deg = css`
  background: transparent
    linear-gradient(
      270deg,
      var(--legacy-layer-a-end, #020617) 0%,
      var(--legacy-layer-a-start, #1e293b) 50%,
      var(--legacy-layer-a-end, #020617) 100%
    )
    0% 0% no-repeat padding-box;
  box-shadow: var(--legacy-layer-shadow, inset 1px 1px 2px #ffffff29, 0px 0px 1px #000000);
  border: 0.5px solid var(--legacy-layer-border, #000000);
`;

export const layerA = css`
  background: var(--legacy-layer-a-solid, #1e293b);
  box-shadow: var(--legacy-layer-inset-shadow, inset 0px 0px 3px #000000);
`;
export const layerADark = css`
  background: var(--legacy-layer-a-dark, #1e293b);
  box-shadow: var(--legacy-layer-inset-shadow-strong, inset 0px 0px 6px #000000);
`;

export const layerBDark = css`
  background: var(--legacy-layer-b-dark, #1b2b44);
  box-shadow: var(--legacy-layer-inset-shadow-strong, inset 0px 0px 6px #000000);
`;

export const layerBMedium = css`
  background: var(--legacy-layer-b, #1b2b44);
  box-shadow: var(--legacy-layer-inset-shadow, inset 0px 0px 3px #000000);
`;

export const layerB = css`
  background: var(--legacy-layer-b, #1b2b44);
  box-shadow: var(--legacy-layer-inset-shadow-soft, inset 0px 0px 1px #000000);
`;

export const layerBGreen = css`
  background: #14532d;
  box-shadow: inset 0px 0px 1px #000000;
`;

export const layerC = css`
  background: var(--legacy-layer-c, #142033);
  box-shadow: var(--legacy-layer-inset-shadow-strong, inset 0px 0px 6px #000000);
`;
export const layerCLighter = css`
  background: var(--legacy-layer-c, #142033);
  box-shadow: var(--legacy-layer-inset-shadow-soft, inset 0px 0px 1px #000000);
`;

export const layerADisabled = css`
  background: var(--legacy-layer-disabled-start, #475569);
  box-shadow: var(--legacy-layer-inset-shadow, inset 0px 0px 2px #000000);
`;

export const layerBDisabled = css`
  background: var(--legacy-layer-disabled-b, #334155);
  box-shadow: var(--legacy-layer-inset-shadow-strong, inset 0px 0px 6px #000000);
`;

export const layerCDisabled = css`
  background: var(--legacy-layer-disabled-c, #393939);
  box-shadow: var(--legacy-layer-inset-shadow-soft, inset 0px 0px 1px #000000);
`;

export const layerCDarkDisabled = css`
  background: var(--legacy-layer-disabled-c, #393939);
  box-shadow: var(--legacy-layer-inset-shadow-strong, inset 0px 0px 6px #000000);
`;

export const layerDDark = css`
  background: #0f172a;
  box-shadow: inset 0px 0px 6px #000000;
`;

export const layerDDisabled = css`
  background: #242424;
  box-shadow: inset 0px 0px 6px #000000;
`;
export const layerE = css`
  background-color: rgba(74, 222, 128, 0.2);
  box-shadow: 0px 0px 4px #000000;
`;

export const borderBlue = css`
  border: 1px solid #1e293b;
`;

export const borderABlue = css`
  border: 1px solid #142033;
`;

export const borderBBlue = css`
  border: 1px solid #0f172a;
`;

export const borderC = css`
  border: 1px solid #1b2b44;
`;

export const borderDisabled = css`
  border: 1px solid #334155;
`;

export const borderADisabled = css`
  border: 1px solid #707070;
`;

export const selectionCircleBorder = css`
  border: 1px solid rgba(74, 222, 128, 1);
`;
export const fontColorA = css`
  color: #1b2b44;
`;

export const messageBoxBackground = css`
  background: transparent linear-gradient(180deg, #77777742 0%, #c2c2c224 100%);
  box-shadow: inset 0px 1px 1px #ffffff24, 0px 0px 6px #000000;
  border: 0.5px solid #000000;
`;

export const readyTop180Deg = css`
  background: transparent linear-gradient(180deg, #22d3ee 0%, #1e40af 100%);
  box-shadow: inset 0px 0.5px 1px #ffffff24, 0px 0px 1px #000000;
  border: 0.5px solid #000000;
`;
export const activeLayer180Deg = css`
  background: transparent linear-gradient(180deg, #22c55e 0%, #14532d 100%);
  box-shadow: inset 0px 0.5px 1px #ffffff24, 0px 0px 1px #000000;
  border: 0.5px solid #000000;
`;

export const activeInput = css`
  background: #14532d;
  box-shadow: inset 0px 0px 3px #000000;
`;

export const MC_SELECTED_READY = css`
  border: 1px solid #22d3ee;
`;
export const MC_SELECTED = css`
  border: 1px solid #4ade80;
`;

export const marginBottom = css`
  margin-bottom: 5px;
`;

export const ssrHole = css`
  background: var(--legacy-layer-c, #142033);
  box-shadow: var(--legacy-layer-inset-shadow-soft, inset 0px 0px 1px #000000);
`;

export const ssrOn = css`
  background: transparent linear-gradient(180deg, #22c55e 0%, #14532d 100%);
  box-shadow: inset 0px 0.5px 1px #ffffff24, 0px 0px 1px #000000;
  border: 0.5px solid #000000;
  border-radius: 25px;
`;

export const ssrOff = css`
  background: transparent linear-gradient(180deg, #475569 0%, #1d1d1d 100%);
  box-shadow: inset 0px 0.5px 1px #ffffff24, 0px 0px 1px #000000;
  border: 0.5px solid #000000;
`;

export const ControllerDisabledBackground = css`
  background: transparent linear-gradient(90deg, #475569 0%, #1d1d1d 100%);
  box-shadow: inset 0px 0.5px 1px #ffffff24, 0px 0px 1px #000000;
  border: 0.5px solid #000000;
  border-radius: 4px;
`;

export const ControllerEnabledBackground = css`
  background: transparent linear-gradient(90deg, #1e293b 0%, #020617 100%);
  box-shadow: inset 0px 0.5px 1px #ffffff24, 0px 0px 1px #000000;
  border: 0.5px solid #000000;
  border-radius: 4px;
  background-image: -webkit-linear-gradient(
    180deg,
    rgb(0, 0, 0) 0%,
    rgb(30, 41, 59) 100%
  );

  box-shadow: 0 0 2px rgba(0, 0, 0, 100%);
`;

export const DisableApplyButtonBG = css`
  background: transparent linear-gradient(180deg, #475569 0%, #1d1d1d 100%);
  box-shadow: inset 0px 0.5px 1px #ffffff24, 0px 0px 1px #000000;
  border: 0.5px solid #000000;
`;

export const DisableApplyButtonHole = css`
  background: #334155;
  box-shadow: inset 0px 0px 1px #000000;
`;

export const DisableButtonIndentTop = css`
  background: #334155;
  box-shadow: inset 0px 0px 6px #000000;
`;

export const ItemBackground = css`
  background: var(--legacy-layer-a-solid, #1e293b);
  box-shadow: var(--legacy-layer-inset-shadow, inset 0px 0px 2px #000000);
  border-radius: 12px;
`;

export const ItemBackgroundDisable = css`
  background: var(--legacy-layer-disabled-b, #334155);
  box-shadow: var(--legacy-layer-inset-shadow, inset 0px 0px 2px #000000);

  border-radius: 12px;
`;
export const grayModeLayer = css`
  background: transparent linear-gradient(180deg, #475569 0%, #1d1d1d 100%) 0%
    0% no-repeat padding-box;
  box-shadow: inset 0px 0.5px 1px #ffffff24, 0px 0px 1px #000000;
  border: 0.5px solid #000000;
`;

export const ButtonReady = css`
  background: transparent linear-gradient(180deg, #22d3ee 0%, #1e40af 100%);
  box-shadow: inset 0px 0.5px 1px #ffffff24, 0px 0px 1px #000000;
  border: 0.5px solid #000000;
`;


export const layer2HorizontalGradient = css`
  border-style: solid;
  border-width: 0.5px;
  border-color: rgb(0, 0, 0);

  background-image: -webkit-linear-gradient(
    90deg,
    rgb(0, 0, 0) 0%,
    rgb(30, 41, 59) 100%
  );

  box-shadow: inset 0 1px 1px rgba(255, 255, 255, 14%);
  box-shadow: 0 0 2px rgba(0, 0, 0, 100%);
`;


export const layer2VerticalGradient = css`
  border-style: solid;
  border-width: 0.5px;
  border-color: rgb(0, 0, 0);

  background-image: -webkit-linear-gradient(
    180deg,
    rgb(0, 0, 0) 0%,
    rgb(30, 41, 59) 100%
  );

  box-shadow: inset 0 1px 1px rgba(255, 255, 255, 14%);
  box-shadow: 0 0 2px rgba(0, 0, 0, 100%);
`;


export const activeLayer = css`
  background: transparent linear-gradient(180deg, #22c55e 0%, #14532d 100%) 0%
    0% no-repeat padding-box;
  box-shadow: inset 0px 0.5px 1px #ffffff24, 0px 0px 1px #000000;
  border: 0.5px solid #000000;
`;


export const createScrollbarY = (color = '#475569') => css`
  scroll-behavior: smooth;
  overflow-y: auto;
  overflow-x: hidden;

  ::-webkit-scrollbar {
    width: 10px;
    border: 1px solid ${color};
    border-radius: 13px;
  }
  ::-webkit-scrollbar-track {
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${color};
    border-radius: 13px;
    border: 1.5px solid transparent;
    background-clip: padding-box;
    height: 40%;
  }

  ::-webkit-scrollbar-button:start:decrement {
    background-repeat: no-repeat;
    background-size: 70%;
    background-position: center;
    height: 10px;

    background-image: url('/images/scrollbar-button-start.svg');
  }
  ::-webkit-scrollbar-button:end:increment {
    background-repeat: no-repeat;
    background-size: 70%;
    background-position: center;
    height: 10px;

    background-image: url('/images/scrollbar-button-end.svg');
  }
`;

export const scrollbarY = createScrollbarY();

export const scrollbarHidden = css`
  overflow-y: auto;
  ::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`;

export const scrollbarX = css`
  scroll-behavior: smooth;
  overflow-x: scroll;
  overflow-y: hidden;

  ::-webkit-scrollbar {
    width: 14px;
    height: 14px;
    border: 1px solid #475569;
    border-radius: 13px;
  }
  ::-webkit-scrollbar-track {
  }

  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #475569;
    border-radius: 13px;
    border: 1.5px solid transparent;
    background-clip: padding-box;
    height: 40%;
  }

  ::-webkit-scrollbar-button:start:decrement:vertical {
    background-repeat: no-repeat;
    background-size: 40%;
    background-position: center;
    height: 10px;

    background-image: url('/images/scrollbar-button-vertical.svg');
  }
  ::-webkit-scrollbar-button:end:increment:vertical {
    background-repeat: no-repeat;
    background-size: 70%;
    background-position: center;
    height: 10px;

    background-image: url('/images/scrollbar-button-vertical1.svg');
  }
  ::-webkit-scrollbar-button:start:decrement:horizontal {
    background-repeat: no-repeat;
    background-size: 70%;
    background-position: center;
    height: 10px;

    background-image: url('/images/scrollbar-button-horizontal1.svg');
  }
  ::-webkit-scrollbar-button:end:increment:horizontal {
    background-repeat: no-repeat;
    background-size: 70%;
    background-position: center;
    height: 10px;

    background-image: url('/images/scrollbar-button-horizontal.svg');
  }
`;



export const cardPanel = css`
  background: var(--bg-card);
  border: 0.8px solid var(--border-card);
  border-radius: 14px;
  box-shadow: var(--shadow-card);
  transition: background 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;
`;

export const cardInput = css`
  background: var(--bg-input);
  border: 0.8px solid var(--border-input);
  border-radius: 10px;
  transition: background 0.3s ease, border-color 0.3s ease;
`;

export const cardButton = css`
  background: var(--bg-button);
  border: 0.8px solid var(--border-button);
  border-radius: 10px;
  box-shadow: var(--shadow-button);
  transition: background 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;
`;

export const layerHPA = css`
  background: #1e293b;
  box-shadow: 0px 0px 2px 0px #000 inset;
`;

export const layerHPB = css`
  background: #142033 0% 0% no-repeat padding-box;
  box-shadow: inset 0px 0.5px 1px #ffffff24, 0px 0px 1px #000000;
  border: 0.5px solid #000000;
`;

export const layerDegHPA = css`
  border: 0.5px solid #000;
  background: var(
    --Gradiente-umbrella,
    linear-gradient(0deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.2) 100%),
    linear-gradient(180deg, #1e293b 0%, #1e293b 44%, #020617 100%)
  );
  box-shadow: 0px 0px 2px 0px #000;
`;

export const layerDegHPB = css`
  border: 0.5px solid #000;
  background: linear-gradient(180deg, #1e293b 0%, #020617 100%);
  box-shadow: 0px 0.5px 1px 0px rgba(255, 255, 255, 0.25) inset;
`;

export const layerDegHPC = css`
  background: var(
    --Light_blue_100,
    linear-gradient(0deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.2) 100%),
    #1e293b
  );
  box-shadow: 0px 0px 3px 0px #000 inset;
`;

export const layerDegHPD = css`
  background: var(
    --Gradiente-umbrella,
    linear-gradient(0deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.2) 100%),
    linear-gradient(180deg, #1e293b 0%, #1e293b 44%, #020617 100%)
  );
  border: 0.5px solid #000;
`;

export const layerHPE = css`
  border: 0.5px solid #000;
  background: linear-gradient(
    180deg,
    #1e293b 0%,
    #020617 100%,
    #020617 100%,
    #020617 100%
  );
  box-shadow: 0px 0px 2px 0px #000;
`;

export const layerHPF = css`
  background: transparent
    linear-gradient(180deg, #d9d24b 0%, #aea951 61%, #67665c 100%) 0% 0%
    no-repeat padding-box;
  box-shadow: 0px 0px 3px #000000;
`;

export const layerHPG = css`
  background: transparent linear-gradient(180deg, #2e2e1e 0%, #fef100 100%) 0%
    0% no-repeat padding-box;
  border: 1px solid #ffe600;
`;



export const radioButtonOuter = css`
  width: 22px;
  height: 22px;
  border-radius: 50%;
  ${selectionCircleBorder};
  ${flexBoxCenter};
`;

export const radioButtonInner = css`
  width: 14px;
  height: 14px;
  border-radius: 50%;
`;

export const flexboxCenter = css`
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
`;
